export function generatePetId(): string {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID()
    }

    return `pet-${Date.now()}-${Math.random().toString(36).slice(2)}`
}
